export default {
  "content": "<g clip-path=\"url(#prefix__clip0)\"><path fill=\"#3F4450\" d=\"M.39 7.927a.4.4 0 01-.015-.56l4.68-5.025c.21-.225.505-.35.81-.35.305.005.6.135.805.365l4.475 4.99a.4.4 0 01-.025.56l-.48.445a.403.403 0 01-.57-.025L5.85 3.612l-4.42 4.75a.399.399 0 01-.57.015l-.47-.45z\"/></g><defs><clipPath id=\"prefix__clip0\"><path fill=\"#fff\" d=\"M0 0h6.5v10.985H0z\" transform=\"rotate(90 4.629 6.621)\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "12",
    "height": "12",
    "fill": "none"
  }
};